<div class="site-page-header-ghost-wrapper">
    <nz-page-header nzBackIcon [nzGhost]="false">
        <nz-page-header-title>Medicamentos</nz-page-header-title>
        <nz-page-header-subtitle class="hide-xs"> - Lista de medicamentos cadastrados.</nz-page-header-subtitle>
        <nz-page-header-extra>
            <button nz-button class="hide-xs" style="margin-right: 10px;" (click)="mostrarModalImportacao()">Importar (Excel)</button>
            <button nz-button nzType="primary" routerLink="/medicamento/cadastrar">Cadastrar</button>
            <button nz-button nz-dropdown [nzDropdownMenu]="menu" style="border: none; padding: 0">
                <i nz-icon nzType="ellipsis" nzTheme="outline" style="font-size: 20px; vertical-align: top;"></i>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                    <li nz-menu-item routerLink="/medicamento/importacao-excel">Arquivos Importados</li>
                    <li nz-menu-item (click)="abrirModalPreviaHistoricoAlteracoes()">Prévia do Histórico de Alterações</li>
                </ul>
            </nz-dropdown-menu>
        </nz-page-header-extra>
    </nz-page-header>

    <div nz-row [nzGutter]="12">
        <div nz-col nzMd="24" nzXs="24" style="margin-bottom: 20px;">
            <nz-form-label>Pesquisar Por</nz-form-label>
            <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzAddOnBefore]="addOnBeforeTemplate">
                <input type="text" [(ngModel)]="pesquisa" nz-input placeholder="Digite o que deseja pesquisar" />
            </nz-input-group>
            <ng-template #addOnBeforeTemplate>
                <nz-select style="min-width: 150px!important;" [(ngModel)]="tipoPesquisa">
                    <nz-option nzLabel="Nome" nzValue="descricao"></nz-option>
                    <nz-option nzLabel="Cod. Barras" nzValue="ean"></nz-option>
                    <nz-option nzLabel="Laboratório" nzValue="laboratorio"></nz-option>
                    <nz-option nzLabel="Autorizador" nzValue="autorizador"></nz-option>
                    <nz-option nzLabel="Programa" nzValue="programa"></nz-option>
                    <nz-option nzLabel="Princípio Ativo" nzValue="principio_ativo"></nz-option>
                </nz-select>
            </ng-template>
            <ng-template #suffixButton>
                <button nz-button nzType="primary" (click)="searchMedicamento()" nzSearch>Pesquisar</button>
            </ng-template>
        </div>
        <div nz-col nzMd="24" nzXs="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="medicamentos" [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Cod. Barras</th>
                        <th>Descrição</th>
                        <th style="text-align:center;">Autorizador</th>
                        <th>Desconto</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td>
                                <span *ngIf="data.ativo">{{ data.idmedicamento }}</span>
                                <i style="color:gray;" *ngIf="!data.ativo">{{ data.idmedicamento }}</i>
                            </td>
                            <td>
                                <span *ngIf="data.ativo"> {{ data.ean}}</span>
                                <i style="color:gray;" *ngIf="!data.ativo"> {{ data.ean}}</i>
                            </td>
                            <td>
                                <span *ngIf="data.ativo"> 
                                    {{ data.descricao}} <br *ngIf="data.data_ultima_att">
                                    <small *ngIf="data.data_ultima_att"><strong>Última Atualização: </strong> {{data.data_ultima_att | date: 'dd/MM/yyyy HH:mm:ss'}}</small>
                                </span>
                                <i style="color:gray;" *ngIf="!data.ativo"> {{ data.descricao}}</i>
                            </td>
                            <td style="text-align:center;">
                                <span *ngIf="data.ativo"> 
                                    {{data.programa.autorizador.nome}} <br>
                                    {{ data.programa.nome}}
                                </span>
                                <i style="color:gray;" *ngIf="!data.ativo">
                                        {{data.programa.autorizador.nome}} <br> 
                                    {{ data.programa.nome}}
                                </i>
                            </td>
                            <td>
                                <span *ngIf="data.ativo && isNumeric(data.descontos[0]?.desconto)"> {{ (data.descontos[0].desconto - 0) + '% '}}</span>
                                <span *ngIf="data.ativo && !isNumeric(data.descontos[0]?.desconto)"> {{ data.descontos[0].desconto}}</span>
                                <i style="color:gray;" *ngIf="!data.ativo && isNumeric(data.descontos[0]?.desconto)"> {{ data.descontos[0].desconto - 0}}%</i>
                                <i style="color:gray;" *ngIf="!data.ativo && !isNumeric(data.descontos[0]?.desconto)"> {{ data.descontos[0].desconto}}</i>
                            </td>

                            <td>
                                   <button nz-button (click)="openModalDetalhe(data.idmedicamento)">
                                        Mais Informações</button>
                               <button nz-button nz-dropdown [nzDropdownMenu]="menu1" nzPlacement="bottomRight">
                                        <i nz-icon nzType="ellipsis"></i>
                                    </button>
                                <nz-dropdown-menu #menu1="nzDropdownMenu">
                                    <ul nz-menu>
                                        <li nz-menu-item routerLink="/medicamento/cadastrar/{{data.idmedicamento}}" *ngIf="data.ativo">
                                            Editar</li>
                                        <li nz-menu-item style="color:green" *ngIf="!data.ativo" (click)="ativar(data.idmedicamento)">Ativar</li>
                                        <li nz-menu-item style="color:red;" *ngIf="data.ativo" (click)="inativar(data.idmedicamento)">Inativar</li>
                                    </ul>
                                </nz-dropdown-menu>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>

<nz-drawer [nzVisible]="isVisibleDetalhe" [nzWidth]="640" (nzOnClose)="closeModalDetalhe()">
<ng-container *nzDrawerContent>
    <nz-descriptions [nzColumn]="2" nzTitle="Dados Principais" *ngFor="let d of medicamentoModal">
        <nz-descriptions-item nzTitle="Cod. de Barras" [nzSpan]="1">{{d.ean}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Laboratório" [nzSpan]="1">{{d.laboratorio.descricao}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Medicamento" [nzSpan]="2">{{d.descricao}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Observação" [nzSpan]="2">{{d.observacao}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Autorizador" [nzSpan]="1">{{d.programa.autorizador.nome}} - ({{d.programa.nome}})</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Medicamento Controlado" [nzSpan]="1">{{d.controlado ? 'Sim' : 'Não'}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Site" [nzSpan]="1"><a href="{{d.site}}" target="_blank">Acessar Site</a></nz-descriptions-item>
        <nz-descriptions-item nzTitle="Telefone" [nzSpan]="1">{{d.telefone}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Princípios Ativos" [nzSpan]="2">{{formatarPrincipiosAtivos(d.principios_ativos)}}</nz-descriptions-item>
    </nz-descriptions>

    <nz-divider></nz-divider>

    <div class="ant-descriptions-title ng-star-inserted">Descontos </div>
    <div *ngFor="let d of medicamentoModal">
        <nz-table #nestedTable [nzData]="d.descontos">
            <thead>
                <tr>
                    <th style="text-align:center;">Desconto</th>
                    <th style="text-align:center;">Observação</th>
                </tr>
            </thead>
            <tbody>
                <ng-template ngFor let-data [(ngForOf)]="nestedTable.data">
                    <tr>
                        <td style="text-align:center;" *ngIf="isNumeric(data.desconto)">{{data.desconto - 0}}%</td>
                        <td style="text-align:center;" *ngIf="!isNumeric(data.desconto)">{{data.desconto}}</td>
                        <td style="text-align:center;">{{data.obs_desconto}}</td>
                    </tr>
                </ng-template>
            </tbody>
        </nz-table>
    </div>
    </ng-container>
</nz-drawer>

<nz-modal [(nzVisible)]="visibleModalImportacao" nzTitle="Importação de Medicamentos" (nzOnCancel)="fecharModalImportacao()" nzWidth="820px">
    <ng-container *nzModalContent>
    <app-importacao-excel (eventCloseModal)="fecharModalImportacao()"></app-importacao-excel>
    </ng-container>
    <div *nzModalFooter>
    </div>
</nz-modal>


<nz-modal [(nzVisible)]="visibleModalPreviaHistoricoAlteracoes" [nzFooter]="null" nzTitle="Prévia do Histórico de Alterações" (nzOnCancel)="fecharModalPreviaHistoricoAlteracoes()" nzWidth="820px">
    <ng-container *nzModalContent>
    <app-previa-historico-alteracoes *ngIf="visibleModalPreviaHistoricoAlteracoes"></app-previa-historico-alteracoes>
    </ng-container>
</nz-modal>